import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import {
  baseUrl,
  noOfGullaList,
  rotliTypeList,
  batchSize,
  heightSelectionList,
} from "../comman/config";
import Select from "react-select";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { DateSessionFilter } from "../components/Filter/DateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';
import { menuAboveTable, withMenuOnTop } from "../comman/selectMenu";

// The dropdowns sit in the batch columns, which are narrow. A placeholder left free to wrap would
// grow its own row taller than the row name it is lined up against, so placeholders are held to one
// line and ellipsised. The cream fill marks a dropdown as one to answer, the way bg-orange-50 marks
// the plain inputs; the dropdowns that are read-only reference use the unfilled variant.
const batchSelectPlaceholder = (provided) => ({
  ...provided,
  fontSize: "0.80rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const batchSelectStyles = {
  placeholder: batchSelectPlaceholder,
  control: (provided) => ({
    ...provided,
    backgroundColor: "#FFFAF0",
    fontSize: "16px",
  }),
};

const batchSelectStylesNoFill = { placeholder: batchSelectPlaceholder };

// Kgs and Litres are two ways of measuring one lot of excess -- and Readymade Kgs and Readymade
// Ltrs likewise. Excess Bowl nos. counts bowls, which is a property of the excess itself and not of
// the unit it is reported in, so an item measured both ways carries one count: entered under Kgs it
// stands under Litres, and the other way round.
const COUNTERPART_METHOD = { 1: 2, 2: 1, 4: 5, 5: 4 };

// Fill in Excess Bowl nos. from the item's other measurement, for batches that have none of their
// own. A count entered under this method always wins -- this only speaks where the method is silent.
const shareExcessBowlNos = (rows, method, counterpartExcessDetail) => {
  if (!COUNTERPART_METHOD[method] || !counterpartExcessDetail?.length) return rows;
  return rows.map((row) => {
    if (parseFloat(row.excess_bowl_nos) > 0) return row;
    const counterpart = counterpartExcessDetail.find((object) => object.batch == row.batch);
    if (!(parseFloat(counterpart?.excess_bowl_nos) > 0)) return row;
    const excess_bowl_nos = counterpart.excess_bowl_nos;
    // What hangs off the count has to move with it. Both figures are derived per batch as the
    // count is typed; a borrowed count arrives without that keystroke, so they are derived here
    // too -- otherwise the screen would show bowls of excess that its own total leaves out.
    if (method == 1 || method == 4) {
      const bowl_filled_weight_b = (excess_bowl_nos * (parseFloat(row.weight_of_1_filled_bowl) || 0)).toFixed(2);
      const total_weight = ((parseFloat(row.net_weight_fg_a) || 0) + parseFloat(bowl_filled_weight_b)).toFixed(2);
      return { ...row, excess_bowl_nos, bowl_filled_weight_b, total_weight };
    }
    const bowl_filled_volume = (excess_bowl_nos * (parseFloat(row.volume_of_1_filled_bowl) || 0)).toFixed(2);
    const total_volume = ((parseFloat(row.vessel_volume) || 0) + parseFloat(bowl_filled_volume)).toFixed(2);
    return { ...row, excess_bowl_nos, bowl_filled_volume, total_volume };
  });
};

function ExcessScreen() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [filteredList,setFilteredList] = useState([])
  const [methodList, setMethodList] = useState([]);
  const [methodType, setMethodType] = useState(0);
  const [activeIndex, setActiveIndex] = useState(null);
  const [batchIndex, setBatchIndex] = useState(0);
  const [bowlList, setBowlList] = useState([]);
  const [date, setDate] = useState(today);
  const [session, setSession] = useState("");
  const [method, setMethod] = useState("")
  const [formData, setFormData] = useState([]);
  const [vesselList, setVesselList] = useState([]);
  const [trollyList, setTrollyList] = useState([]);
  const [filleHegithChange, setFilleHegithChange] = useState(false);
  const [loading, setLoading] = useState(false) 
  
  useEffect(() => {
    getBowlList();
    getVesselList();
    getTrollyList();
    getMethodList();
  }, []);
  useEffect(()=>{
    console.log(formData)
  },[formData])
  useEffect(() => {
    // Create initial formData and validationErrors based on mealList length
    const initialFormData = Array.from({ length: batchSize }, (_, index) => ({
      batch: index + 1,
      trolly_name: "",
      vessel_name: { value: "unknown", label: "Unknown" },
      gross_weight_fg: "",
      weight_of_empty_trolly: "",
      weight_of_empty_vessel: "",
      net_weight_fg_a: "",
      weight_of_1_filled_bowl: "",
      bowl_filled_weight_b: "",
      total_weight: "",
      height_selection: { value: 1, label: "Filled Height" },
      height : "",
      vessel_diameter: "",
      empty_height: "",
      filled_height: "",
      vessel_volume: "",
      excess_bowl_nos: "",
      volume_of_1_filled_bowl: "",
      bowl_filled_volume: "",
      total_volume: "",
      gross_weight: "",
      weight_of_1_empty_bowl_icebox: "",
      no_of_bowl_icebox: "",
      total_weight_of_empty_bowl_icebox: "",
      net_weight_of_rotis: "",
      weight_of_1_roti: "",
      no_of_rotis_a: "",
      no_of_bowl_icebox_b: "",
      nos_in_1_bowl_icebox: "",
      no_of_rotis_b: "",
      no_of_rotis_c: "",
      total_no_of_roti: "",
    }));
    setFormData(initialFormData);
    // setIntialFormData(initialFormData);
  }, [batchSize]);

  useEffect(()=>{
    console.log('method',method)
    console.log(mealList)
    let filterlist;
        // console.log(method);
    if(method && method.length > 0){
        const methodIds = method.map(method => method.value);
        filterlist = mealList.filter((item) => item?.measurements?.id && methodIds.includes(item?.measurements?.id));
    } else{
      filterlist = mealList.filter((item) => item?.measurements?.id);
    }  
    console.log(filterlist)
    setFilteredList(filterlist);
    // Re-filtering renumbers every row, so whatever was open is no longer the row the user
    // opened. Closing it is the honest answer; leaving it open reintroduces the mismatch above
    // by another route.
    setActiveIndex(null);
  },[method,mealList])

  // activeIndex is an index into filteredList -- that is the list the accordion renders and the
  // list handleClick counts against -- so it has to be resolved against filteredList too.
  //
  // It used to be resolved against mealList, which is the unfiltered one. The two lists only line
  // up while the filter removes nothing, and the filter removes plenty: every row whose item has
  // no measurement, and every row outside the methods picked in the Method dropdown. Selecting
  // Kgs and Ltrs on a day that also has a Nos item shifts the lists apart at that item and every
  // row after it opens somebody else's data -- which is why Excess Bowl nos. did not appear under
  // the second measurement. It was reading a different item's row, and, further down, saving to
  // one.
  useEffect(() => {
    if (filteredList.length > 0 && activeIndex != null) {
      const item = filteredList[activeIndex] ?? null;
      if (!item) return;
      const itemId = item.menu_item_id ?? null;
      const method = item?.measurements?.id ?? item.method;
      setMethodType(method);
      const fetchDetail = async () => {
        setLoading(true)
        const condition = `date = '${date}' AND session = '${session.value}' AND menu_item_id = '${itemId}' AND method = '${method}'`;
        const mealMasterCondition = `date = '${date}' AND session = '${session.value}' AND menu_item_id = '${itemId}'`;
        // The item's other measurement, asked for only so Excess Bowl nos. can be carried across.
        // An item measured just one way simply has no rows there.
        const counterpartMethod = COUNTERPART_METHOD[method];
        const counterpartCondition = `date = '${date}' AND session = '${session.value}' AND menu_item_id = '${itemId}' AND method = '${counterpartMethod}'`;
        const bd = (await axios.post(`${baseUrl}/comman/batch-list`, { queries: [
          { key: 'bowl',   table: 'bowl_screen',   condition },
          { key: 'excess', table: 'excess_screen',  condition },
          { key: 'meal',   table: 'meal_master',    condition: mealMasterCondition },
          { key: 'fg',     table: 'finished_goods', condition },
          ...(counterpartMethod
            ? [{ key: 'counterpart_excess', table: 'excess_screen', condition: counterpartCondition }]
            : []),
        ]})).data.data;
        const bowlDetail = bd.bowl ?? [];
        const excessDetail = bd.excess ?? [];
        const mealDetail = bd.meal ?? [];
        const finishedGoodsDetail = bd.fg ?? [];
        const counterpartExcessDetail = bd.counterpart_excess ?? [];
        getDetailDispaly(bowlDetail, excessDetail,mealDetail,finishedGoodsDetail, method, counterpartExcessDetail);
        setLoading(false)
      };
      fetchDetail();
    }
  }, [filteredList, activeIndex]);

  const getDetailDispaly = async (bowlDetail, excessDetail,mealDetail,finishedGoodsDetail, method, counterpartExcessDetail = []) => {
    console.log('mealDetail',mealDetail)
    try {
      if (bowlDetail || excessDetail) {
        const initialFormData = Array.from(
          { length: batchSize },
          (_, index) => ({
            batch: index + 1,
            trolly_name: "",
            vessel_name: { value: "unknown", label: "Unknown" },
            gross_weight_fg: "",
            weight_of_empty_trolly: "",
            weight_of_empty_vessel: "",
            net_weight_fg_a: "",
            weight_of_1_filled_bowl: mealDetail[0]?.avg_qty_in_1_bowl_kgs ?? "",
            bowl_filled_weight_b: "",
            total_weight: "",
            height_selection: { value: 1, label: "Filled Height" },
            vessel_diameter: "",
            empty_height: "",
            filled_height: "",
            vessel_volume: "",
            excess_bowl_nos: "",
            volume_of_1_filled_bowl: mealDetail[0]?.avg_qty_in_1_bowl_ltr ?? "",
            bowl_filled_volume: "",
            total_volume: "",
            gross_weight: "",
            weight_of_1_empty_bowl_icebox: "",
            no_of_bowl_icebox: "",
            total_weight_of_empty_bowl_icebox: "",
            net_weight_of_rotis: "",
            weight_of_1_roti: "",
            no_of_rotis_a: "",
            no_of_bowl_icebox_b: "",
            nos_in_1_bowl_icebox: "",
            no_of_rotis_b: "",
            no_of_rotis_c: "",
            total_no_of_roti: "",
          })
        );
        const updatedFormData = initialFormData.map((initialItem) => {
          const bowlObject = bowlDetail.find(
            (object) => object.batch == initialItem.batch
          );
          const excessObject = excessDetail.find(
            (object) => object.batch == initialItem.batch
          );
          const finishedGoodsObject = finishedGoodsDetail.find(
            (object) => object.batch == initialItem.batch
          )
          console.log(finishedGoodsObject)
          const firstBatchFinishedGoodsObject = finishedGoodsDetail.find((object) => object.batch == 1);
          console.log('first batch',firstBatchFinishedGoodsObject)
          initialItem.weight_of_1_roti = (method == 3)
                ? (firstBatchFinishedGoodsObject?.avg_finished_roti_weight ?? 0)
                : (method == 6 ? firstBatchFinishedGoodsObject?.weight_of_1_readymade_no ?? 0 : 0);
          initialItem.nos_in_1_bowl_icebox = finishedGoodsObject?.rotis_in_1_icebox_bowl ?? ""
          if (bowlObject && !excessObject) {
            if (method == 1 || method == 4) {
              initialItem.weight_of_1_filled_bowl =
                bowlObject.avg_weight_of_1_filled_bowl;
            }
            if (method == 2 || method == 5) {
              initialItem.volume_of_1_filled_bowl =
                bowlObject.avg_volume_of_1_filled_bowl;
            }
            if (method == 3 || method == 6) {
              initialItem.weight_of_1_roti = bowlObject.weight_of_1_roti ?? 0;
              initialItem.weight_of_1_empty_bowl_icebox =
                bowlObject.weight_of_1_empty_bowl_icebox ?? 0;

              // Rotis in 1 icebox: Finished Goods holds this batch's own figure, so it wins. The
              // Bowl screen average below is only a fallback for when Finished Goods has nothing --
              // it used to overwrite unconditionally, so a batch with 288.38 saved on Finished
              // Goods still showed 0 here whenever the bowl rows were blank.
              const fgNosInBowl = parseFloat(finishedGoodsObject?.rotis_in_1_icebox_bowl) || 0;
              if (fgNosInBowl > 0) {
                initialItem.nos_in_1_bowl_icebox = finishedGoodsObject.rotis_in_1_icebox_bowl;
              } else if (bowlDetail.length > 0) {
                const sum = bowlDetail.reduce(
                  (accumulator, currentValue) =>
                    accumulator +
                    (parseFloat(currentValue.no_of_rotis_in_1_bowl_icebox) || 0),
                  0
                );
                // Guarded: an empty bowlDetail divided to NaN, which rendered as "NaN".
                initialItem.nos_in_1_bowl_icebox = (sum / bowlDetail.length).toFixed();
              }
            }
            return { ...initialItem };
          } else if (excessObject) {
            if (method == 1 || method == 4) {
              const trollyItem = trollyList.find(
                (item) => item.id == excessObject.trolly_name
              );
              const trollyNameObject = trollyItem
                ? { value: trollyItem.id, label: trollyItem.name }
                : { value: "", label: "" };

              const isNoVessel = excessObject.vessel_name === 0 || excessObject.vessel_name === "0";
              const vesselItem = isNoVessel ? null : vesselList.find(
                (item) => item.id == excessObject.vessel_name
              );
              const vesselNameObject = isNoVessel
                ? { value: 0, label: "No vessel" }
                : vesselItem
                  ? { value: vesselItem.id, label: vesselItem.name }
                  : { value: "", label: "" };

              initialItem.trolly_name = trollyNameObject;
              initialItem.vessel_name = vesselNameObject;
              initialItem.gross_weight_fg = excessObject.gross_weight_fg;
              initialItem.weight_of_empty_trolly =
                excessObject.weight_of_empty_trolly;
              initialItem.weight_of_empty_vessel =
                excessObject.weight_of_empty_vessel;
              initialItem.net_weight_fg_a = excessObject.net_weight_fg_a;
              initialItem.excess_bowl_nos = excessObject.excess_bowl_nos;
              initialItem.weight_of_1_filled_bowl =
                excessObject.weight_of_1_filled_bowl;
              initialItem.bowl_filled_weight_b =
                excessObject.bowl_filled_weight_b;
              initialItem.total_weight = excessObject.total_weight;
            }
            if (method == 2 || method == 5) {
              // Check if vessel_name is 0 (meaning Unknown was selected)
              const isUnknownVessel = excessObject.vessel_name === 0 || excessObject.vessel_name === "0";
              const vesselItem = isUnknownVessel ? null : vesselList.find(
                (item) => item.id == excessObject.vessel_name
              );
              const vesselNameObject = isUnknownVessel
                ? { value: "unknown", label: "Unknown" }
                : vesselItem
                  ? { value: vesselItem.id, label: vesselItem.name }
                  : { value: "", label: "" };

              initialItem.vessel_name = vesselNameObject;
              // For Unknown vessel, use saved diameter; for known vessel, use vessel's top_dia
              initialItem.vessel_diameter = isUnknownVessel
                ? (excessObject.vessel_diameter ?? "")
                : (vesselItem?.top_dia ?? "");
              const heightItem = heightSelectionList.find(
                (item) => item.value == excessObject.height_selection
              );
              const heightObject = heightItem
                ? { value: heightItem.value, label: heightItem.label }
                : { value: "", label: "" };
              initialItem.height_selection = heightObject;
              initialItem.empty_height = excessObject.empty_height;
              initialItem.filled_height = excessObject.filled_height;
              initialItem.height = excessObject.height;
              initialItem.vessel_volume = excessObject.vessel_volume;
              initialItem.excess_bowl_nos = excessObject.excess_bowl_nos;
              initialItem.volume_of_1_filled_bowl =
                excessObject.volume_of_1_filled_bowl;
              initialItem.bowl_filled_volume = excessObject.bowl_filled_volume;
              initialItem.total_volume = excessObject.total_volume;
            }
            if (method == 3 || method == 6) {
              const trollyItem = trollyList.find(
                (item) => item.id == excessObject.trolly_name
              );
              const trollyNameObject = trollyItem
                ? { value: trollyItem.id, label: trollyItem.name }
                : { value: "", label: "" };
                const bowlTypeItem = bowlList.find(
                  (item) => item.id == excessObject?.bowl_type
                );
                console.log('bowlTypeItem',bowlTypeItem)
                const bowlTypeObject = bowlTypeItem
                  ? { value: bowlTypeItem.id, label: bowlTypeItem.name }
                  : { value: "", label: "" };
              initialItem.trolly_name = trollyNameObject;
              initialItem.weight_of_empty_trolly =
                excessObject.weight_of_empty_trolly;
              initialItem.gross_weight = excessObject.gross_weight;
              initialItem.bowl_type = bowlTypeObject
              initialItem.weight_of_1_empty_bowl_icebox =
                excessObject.weight_of_1_empty_bowl_icebox;
              initialItem.no_of_bowl_icebox = excessObject.no_of_bowl_icebox;
              initialItem.total_weight_of_empty_bowl_icebox =
                excessObject.total_weight_of_empty_bowl_icebox;
              initialItem.net_weight_of_rotis =
                excessObject.net_weight_of_rotis;
                console.log('finishedGoods',finishedGoodsObject)
                initialItem.weight_of_1_roti = excessObject.weight_of_1_roti;
              initialItem.no_of_rotis_a = excessObject.no_of_rotis_a;
              initialItem.no_of_bowl_icebox_b =
                excessObject.no_of_bowl_icebox_b;
              initialItem.nos_in_1_bowl_icebox = (finishedGoodsObject?.rotis_in_1_icebox_bowl ?? 0);
              initialItem.no_of_rotis_b = excessObject.no_of_rotis_b;
              initialItem.no_of_rotis_c = excessObject.no_of_rotis_c;
              initialItem.total_no_of_roti = excessObject.total_no_of_roti;
            }
            return { ...initialItem };
          } else {
            if (method == 3 || method == 6) {
              const defaultBowl = bowlList.find((b) => b.name === "I-1");
              if (defaultBowl) {
                initialItem.bowl_type = { value: defaultBowl.id, label: defaultBowl.name };
                initialItem.weight_of_1_empty_bowl_icebox = defaultBowl.bowl_weight_empty ?? "";
              }
            }
            if (method == 1 || method == 4) {
              initialItem.vessel_name = { value: 0, label: "No vessel" };
              initialItem.weight_of_empty_vessel = 0;
            }
            return { ...initialItem };
          }
        });
        setFormData(shareExcessBowlNos(updatedFormData, method, counterpartExcessDetail));
      } else {
        const initialFormData = Array.from(
          { length: batchSize },
          (_, index) => ({
            batch: index + 1,
            trolly_name: "",
            vessel_name: { value: "unknown", label: "Unknown" },
            gross_weight_fg: "",
            weight_of_empty_trolly: "",
            weight_of_empty_vessel: "",
            net_weight_fg_a: "",
            weight_of_1_filled_bowl: "",
            bowl_filled_weight_b: "",
            total_weight: "",
            height_selection: { value: 1, label: "Filled Height" },
            vessel_diameter: "",
            empty_height: "",
            filled_height: "",
            vessel_volume: "",
            excess_bowl_nos: "",
            volume_of_1_filled_bowl: "",
            bowl_filled_volume: "",
            total_volume: "",
            gross_weight: "",
            weight_of_1_empty_bowl_icebox: "",
            no_of_bowl_icebox: "",
            total_weight_of_empty_bowl_icebox: "",
            net_weight_of_rotis: "",
            weight_of_1_roti: "",
            no_of_rotis_a: "",
            no_of_bowl_icebox_b: "",
            nos_in_1_bowl_icebox: "",
            no_of_rotis_b: "",
            no_of_rotis_c: "",
            total_no_of_roti: "",
          })
        );
        setFormData(initialFormData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const memoizedFormData = formData[batchIndex];
    const memoizedMethodType = methodType;

    if (
      (memoizedMethodType == 1 || memoizedMethodType == 4) &&
      memoizedFormData
    ) {
      const trollyWeight = parseFloat(memoizedFormData.weight_of_empty_trolly);
      const vesselWeight = parseFloat(memoizedFormData.weight_of_empty_vessel);
      const grossFG = parseFloat(memoizedFormData.gross_weight_fg);
      const excessBowlNos = memoizedFormData.excess_bowl_nos;
      const weight_of_1_filled_bowl = memoizedFormData.weight_of_1_filled_bowl;

      const net_weight_fg_a = isNaN(grossFG - (vesselWeight + trollyWeight))
        ? 0
        : (grossFG - (vesselWeight + trollyWeight)).toFixed(2);

      const bowl_filled_weight_b = (
        excessBowlNos * weight_of_1_filled_bowl
      ).toFixed(2);
      const total_weight =
        parseFloat(net_weight_fg_a) + parseFloat(bowl_filled_weight_b) ?? 0;

      // Update formData if necessary
      if (
        memoizedFormData.net_weight_fg_a !== net_weight_fg_a ||
        memoizedFormData.bowl_filled_weight_b !== bowl_filled_weight_b ||
        memoizedFormData.total_weight !== total_weight.toFixed(2)
      ) {
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[batchIndex] = {
            ...updatedFormData[batchIndex],
            net_weight_fg_a: net_weight_fg_a,
            bowl_filled_weight_b: bowl_filled_weight_b,
            total_weight: total_weight.toFixed(2),
          };
          return updatedFormData;
        });
      }
    } else if (
      (memoizedMethodType == 2 || memoizedMethodType == 5) &&
      memoizedFormData
    ) {
      const isUnknownVessel = memoizedFormData?.vessel_name?.value === "unknown";
      const vesselItem = isUnknownVessel ? null : vesselList.find(
        (item) => item.id == memoizedFormData?.vessel_name?.value
      );
      const total_height = vesselItem?.total_height ?? 0;
      const enter_height = memoizedFormData?.height === "" || memoizedFormData?.height == null ? 0 : memoizedFormData.height;
      const height = memoizedFormData?.height_selection?.value == 1 ? enter_height : (total_height - enter_height);

      const empty_height = memoizedFormData.empty_height;

      const excess_bowl_nos = memoizedFormData.excess_bowl_nos;
      const volume_of_1_filled_bowl = memoizedFormData.volume_of_1_filled_bowl;

      const filled_height = filleHegithChange
        ? formData[batchIndex].filled_height
        : isNaN(total_height - empty_height)
        ? 0
        : (total_height - empty_height).toFixed(2) ?? 0;
      // const volume = (3.14 * (d1 / 2) * (d1 / 2) * filled_height) / 1000;
      // const vessel_volume = isNaN(volume) ? 0 : volume.toFixed(2);

      // Use vessel_diameter from formData (allows custom diameter when Unknown is selected)
      const diameter = parseFloat(memoizedFormData?.vessel_diameter) || 0;
      const vessel_rad = diameter / 2;
      const vessel_volume = vessel_rad > 0 ? ((3.14 * vessel_rad * vessel_rad * height) / 1000).toFixed(2) : "0.00";

      const bowl_filled_volume =
        (excess_bowl_nos * volume_of_1_filled_bowl).toFixed(2) ?? 0;

      const total_volume =
        (parseFloat(vessel_volume) + parseFloat(bowl_filled_volume)).toFixed(
          2
        ) ?? 0;

      // Update formData if necessary
      if (
        memoizedFormData.filled_height !== filled_height ||
        memoizedFormData.vessel_volume !== vessel_volume ||
        memoizedFormData.bowl_filled_volume !== bowl_filled_volume ||
        memoizedFormData.total_volume !== total_volume
      ) {
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[batchIndex] = {
            ...updatedFormData[batchIndex],
            filled_height: filled_height,
            vessel_volume: vessel_volume,
            bowl_filled_volume: bowl_filled_volume,
            total_volume: total_volume,
          };
          return updatedFormData;
        });
      }
    } else if (
      (memoizedMethodType == 3 || memoizedMethodType == 6) &&
      memoizedFormData
    ) {
      const no_of_bowl_icebox = memoizedFormData.no_of_bowl_icebox;
      const weight_of_1_empty_bowl_icebox =
        memoizedFormData.weight_of_1_empty_bowl_icebox;
      const gross_weight = memoizedFormData.gross_weight;
      const emptyTrollyWeight = memoizedFormData.weight_of_empty_trolly
      const weight_of_1_roti = memoizedFormData.weight_of_1_roti;
      const no_of_bowl_icebox_b = memoizedFormData.no_of_bowl_icebox_b;
      const nos_in_1_bowl_icebox = memoizedFormData.nos_in_1_bowl_icebox;
      const no_of_rotis_c = memoizedFormData.no_of_rotis_c;

      const total_weight_of_empty_bowl_icebox =
        (no_of_bowl_icebox * weight_of_1_empty_bowl_icebox).toFixed(2) ?? 0;
      const net_weight_of_rotis =
        (gross_weight - emptyTrollyWeight - total_weight_of_empty_bowl_icebox).toFixed(2) ?? 0;
      const no_of_rotis_a =
        weight_of_1_roti > 0
          ? ((net_weight_of_rotis / weight_of_1_roti)*1000).toFixed(2)
          : 0;

      const no_of_rotis_b =
        (no_of_bowl_icebox_b * nos_in_1_bowl_icebox).toFixed(2) ?? 0;

      const total_no_of_roti =
        (
          parseFloat(no_of_rotis_a) +
          parseFloat(no_of_rotis_b) +
          parseFloat(no_of_rotis_c)
        ).toFixed(2) ?? 0;

      // Update formData if necessary
      if (
        memoizedFormData.total_weight_of_empty_bowl_icebox !==
          total_weight_of_empty_bowl_icebox ||
        memoizedFormData.net_weight_of_rotis !== net_weight_of_rotis ||
        memoizedFormData.no_of_rotis_a !== no_of_rotis_a ||
        memoizedFormData.no_of_rotis_b !== no_of_rotis_b ||
        memoizedFormData.total_no_of_roti !== total_no_of_roti
      ) {
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[batchIndex] = {
            ...updatedFormData[batchIndex],
            total_weight_of_empty_bowl_icebox:
              total_weight_of_empty_bowl_icebox,
            net_weight_of_rotis: net_weight_of_rotis,
            no_of_rotis_a: no_of_rotis_a,
            no_of_rotis_b: no_of_rotis_b,
            total_no_of_roti: total_no_of_roti,
          };
          return updatedFormData;
        });
      }
    }
  }, [formData, methodType, batchIndex]);
  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const getBowlList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=bowl_master&condition=status=1`
    );
    setBowlList(response.data.data);
  };

  const getVesselList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=vessel_master&condition=status=1`
    );
    setVesselList(response.data.data);
  };

  const getTrollyList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=trolly_master&condition=status=1`
    );
    setTrollyList(response.data.data);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };

  const handelFilterChange = async (date, session,method) => {
    setDate(date);
    setSession(session);
    setMethod(method)
    if (date && session) {
      const condition = ` m.track_for_report = 1 AND m.session='${session.value}' AND m.date='${date}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/item_list?condition=${condition}`
      );
      const methodResponse = await axios.get(
        `${baseUrl}/comman/list?table=method_master&condition=status=1`
      );
      const methodList = methodResponse?.data?.data
      console.log('PRE LOAD RESPONSE',response.data,methodList)
      const newData = response.data.data.reduce((acc, obj) => {
        const measurementsArray = obj?.measurements?.split(",") ?? [obj.method];
        measurementsArray.forEach((measurement) => {
          acc.push({
            ...obj,
            measurements: methodList.find((v) => v.id == measurement) ?? {},
          });
        });
        return acc;
      }, []);

      console.log(newData);
      setMealList(newData);
    }
  };
  const handleBlur = (index) => (e) => {
    const { name, value } = e.target;
    // setFilleHegithChange(false);
    setFormData((prevFormData)=> {
      const updatedFormData = [...prevFormData];
      const isUnknownVessel = updatedFormData[index].vessel_name?.value === "unknown";
      const vessel = isUnknownVessel ? null : vesselList.find((item) => item.id == updatedFormData[index].vessel_name?.value);
      const total_height = vessel?.total_height ?? 0;
      const enter_height = updatedFormData[index]["height"] === "" || updatedFormData[index]["height"] == null ? 0 : updatedFormData[index]["height"];
      const height = updatedFormData[index]["height_selection"]?.value == 1 ? enter_height : (total_height - enter_height);
      console.log(total_height,enter_height,height)

      // Use vessel_diameter from formData (allows custom diameter when Unknown is selected)
      const diameter = parseFloat(updatedFormData[index]["vessel_diameter"]) || 0;
      const vessel_rad = diameter / 2;
      const volume = vessel_rad > 0 ? ((3.14 * vessel_rad * vessel_rad * height) / 1000).toFixed(2) : "0.00";
      updatedFormData[index] = { ...updatedFormData[index], "height" : updatedFormData[index]["height"], height_selection : updatedFormData[index]["height_selection"], vessel_volume : volume  };

      return updatedFormData
    })
  };
  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    // if (name == "filled_height") {
    //   setFilleHegithChange(true);
    // }
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      return updatedFormData;
    });
    setBatchIndex(index);
  };

  const handleSelectChange = async (index, data, option) => {
    setBatchIndex(index);
    if (methodType == 1 || methodType == 4) {
      if (option.name == "trolly_name") {
        const trollyWeight =
          trollyList.find((item) => item.id == data.value).empty_weight ?? 0;
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
            weight_of_empty_trolly: trollyWeight,
          };
          return updatedFormData;
        });
      }
      if (option.name == "vessel_name") {
        const vesselWeight = data.value === 0
          ? 0
          : vesselList.find((item) => item.id == data.value)?.empty_weight ?? 0;
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
            weight_of_empty_vessel: vesselWeight,
          };
          return updatedFormData;
        });
      }
    }else if(methodType == 2 || methodType == 5){
      if (option.name == "vessel_name") {
        // Check if "Unknown" is selected
        const isUnknown = data.value === "unknown";
        const vessel = isUnknown ? null : vesselList.find((item) => item.id == data.value);
        const total_height = vessel?.total_height ?? 0;
        const vessel_diameter = isUnknown ? "" : (vessel?.top_dia ?? "");
        const vessel_rad = vessel_diameter ? vessel_diameter / 2 : 0;
        const volume = vessel_rad > 0 ? ((3.14 * vessel_rad * vessel_rad * total_height) / 1000).toFixed(2) : "";
        const isV1toV13 = !isUnknown && /^V(1[0-3]|[1-9])$/i.test(data.label);
        const height_selection = isV1toV13
          ? { value: 2, label: "Empty Height" }
          : { value: 1, label: "Filled Height" };

        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
            filled_height: total_height,
            vessel_volume: volume,
            vessel_diameter: vessel_diameter,
            height_selection: height_selection,
          };
          return updatedFormData;
        });
      } else {
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
          };
          return updatedFormData;
        });
      }
    }else if(methodType == 3 || methodType == 6){
      if (option.name == "trolly_name") {
        const trollyWeight =
          trollyList.find((item) => item.id == data.value).empty_weight ?? 0;
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
            weight_of_empty_trolly: trollyWeight,
          };
          return updatedFormData;
        });
      }
      if (option.name == "bowl_type") {
        console.log('bowl',bowlList.find((item)=> item.id == data.value))
        const bowlEmptyWeight =
          bowlList.find((item) => item.id == data.value)?.bowl_weight_empty ?? 0;
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[index] = {
            ...updatedFormData[index],
            [option.name]: data,
            weight_of_1_empty_bowl_icebox: bowlEmptyWeight,
          };
          return updatedFormData;
        });
      }
    } else {
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = {
          ...updatedFormData[index],
          [option.name]: data,
        };
        return updatedFormData;
      });
    }
  };

  const handleSave = async (e, index) => {
    e.preventDefault();

    // filteredList, for the same reason as the fetch above -- this one decides which item the
    // batch is written against, so the mismatch was saving excess to the wrong menu item.
    const menu_item_id = filteredList[activeIndex]?.menu_item_id ?? 0;
    const combineData = {
      formData: formData[index],
      date: date,
      session: session,
      methodType: methodType,
      menu_item_id: menu_item_id,
    };
    console.log(combineData);
    try {
      // setPopupOpen(true);

      await axios.post(`${baseUrl}/excess_screen/batch`, combineData);
      toast.success("Data successfully saved!");
    } catch (error) {
      // setPopupOpen(false);
      toast.error("Failed to submit the form.");
      console.log(error);
    }
  };

  // The final Total is the ITEM's, not the batch's: one figure over all the batches, shown once
  // against the first, the way Finished Goods shows Total Net weight - FG. It read the batch's own
  // A + B and stood in every column, which is five different numbers under one heading that says
  // Total -- and nothing anywhere saying what the item came to.
  //
  // Derived for the screen only. total_weight, total_volume and total_no_of_roti are still worked
  // out per batch and still saved per batch, so excess_screen and everything reading it are
  // untouched; and A and B are still shown per batch above this row, so the figure this replaces
  // is still the sum of two numbers in front of you.
  const excessTotal = (field) =>
    formData
      .reduce((sum, row) => sum + (parseFloat(row?.[field]) || 0), 0)
      .toFixed(2);

  return (
    <div className="">
      {loading && <Loader/>}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Excess
        </h1>
        <div>
                <Link to="/vessel_master/add" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Vessel</button>
                </Link>
                <Link to="/trolly_master/add" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Trolley</button>
                </Link>
        </div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative  shadow-md sm:rounded-lg">
        <DateSessionFilter handleFilterChange={handelFilterChange} />
        <div>
          {filteredList.map((item, index) => (
            <div key={index} className="border-b mt-4">
              <div
                className="flex justify-between items-center p-4 cursor-pointer accordion-title bg-orange-400 border rounded"
                onClick={() => handleClick(index)}
              >
                <span>
                  <ItemNameStacked item={item} /> (
                  {item.measurements.name})
                </span>
                {index === activeIndex ? (
                  <ChevronUpIcon className="w-6 h-6" />
                ) : (
                  <ChevronDownIcon className="w-6 h-6" />
                )}
              </div>
              {index === activeIndex && (
                <div className="space-y-2 p-4 bg-white">
                  <div className="flex overflow-x-auto">
                    {/* Frozen: the row names stay put while the batches scroll past them, so a
                        number in the last batch is still readable as the field it belongs to. Sticky
                        needs an opaque background of its own -- the batches scroll underneath it,
                        not behind the panel. The smaller type is what narrows the column: the labels
                        set their own width, and leading-6 holds each one to the 24px line box the
                        batch rows are spaced against, so shrinking the text cannot drift the
                        alignment. */}
                    <div className="sticky left-0 z-20 bg-white flex mt-10 flex-col whitespace-nowrap text-xs leading-6">
                      <div className="border-l-2 border-l-red-500 border-t-2 border-t-red-500 border-b-red-500">
                        <div className="font-bold mt-[17px] ms-4">Batch</div>
                      </div>

                      {(item?.measurements?.id == 1 ||
                        item?.measurements?.id == 4) && (
                        <>
                          <div className="border-l-2 border-t-2 border-l-red-500 border-t-red-500 border-b-2 border-b-red-500 p-[13px]">
                            <div className="font-bold mt-3">Trolly Name</div>
                            <div className="font-bold mt-7">Vessel Name</div>
                            <div className="font-bold mt-7">
                              Gross weight FG(Kgs.)
                            </div>
                            <div className="font-bold mt-6">
                              Weight of Empty trolley
                            </div>
                            <div className="font-bold mt-7">
                              Weight of Empty vessel
                            </div>
                            <div className="font-bold mt-7">
                              Net weight - FG -(Kgs.) - A
                            </div>
                          </div>

                          <div className="border-l-2 border-l-red-500 border-b-2 border-t-2  p-[13px]">
                            <div className="font-bold ">Excess Bowl nos.</div>
                            <div className="font-bold mt-7">
                              Weight of 1 Filled bowl (kgs.)
                            </div>
                            <div className="font-bold mt-7">
                              Bowl Filled Weight (Kgs.) - B
                            </div>
                          </div>
                          <div className="border-l-2 -mt-[3px] border-l-red-500  border-b-2 border-b-red-500 border-t-2 border-t-red-500 p-[13.5px]">
                            <div className="font-bold ">
                              Total Weight (Kgs.)
                            </div>
                          </div>
                        </>
                      )}
                      {(item?.measurements?.id == 2 ||
                        item?.measurements?.id == 5) && (
                        <>
                          <div className="border-l-2  border-l-red-500  border-t-2 border-t-red-500 p-[13px]">
                            <div className="font-bold mt-[9px]">
                              Vessel Name*
                            </div>
                            <div className="font-bold mt-7">
                              Diameter(cms)
                            </div>
                            <div className="font-bold mt-7">
                              Height Selection</div>
                            <div className="font-bold mt-7">
                              Height(cms)</div>
                            {/* <div className="font-bold mt-5">
                              Empty height (cms)*
                            </div>
                            <div className="font-bold mt-7">
                              Filled height (Cms.)
                            </div> */}
                            <div className="font-bold mt-8">
                              Vessel Volume (Ltrs) - A
                            </div>
                          </div>
                          <div className="border-l-2 -mt-[1px] border-l-red-500   border-t-2 border-t-red-500 p-[13px]">
                            <div className="font-bold mt-[1px]">
                              Excess Bowl nos.
                            </div>
                            <div className="font-bold mt-7">
                              Volume of 1 Filled bowl (ltrs.)
                            </div>
                            <div className="font-bold mt-7">
                              Bowl. Filled Volume (ltrs.) - B
                            </div>
                          </div>
                          <div className="border-l-2  border-l-red-500 border-b-2 border-b-red-500 border-t-2 border-t-red-500 p-[13px]">
                            <div className="font-bold  mt-[1px]">
                              Total Volume (ltrs.)
                            </div>
                          </div>
                        </>
                      )}
                      {(item?.measurements?.id == 3 ||
                        item?.measurements?.id == 6) && (
                        <>
                          <div className="border-l-2 border-t-2 border-l-red-500 border-t-red-500 border-b-2 border-b-red-500 p-[16px]">
                            <div className="font-bold mt-[2px]">
                              Trolly Name
                            </div>
                            <div className="font-bold mt-7">
                              Gross weight (Ice box+Rotli)
                            </div>
                            <div className="font-bold mt-6">
                              Total IceBox (nos)
                            </div>
                            <div className="font-bold mt-7">
                              {item?.measurements?.id == 3 ? 'Weight of 1 roti (gms)' : 'Weight of 1 piece (gms)'}
                            </div>
                            <div className="font-bold mt-7">
                            Empty Trolly Weight (kgs)
                            </div>
                            <div className="font-bold mt-7">
                              Bowl Type
                            </div>
                            <div className="font-bold mt-8">
                              Weight of 1 empty Icebox (kgs)
                            </div>
                            <div className="font-bold mt-8">
                              Total Weight of empty Icebox (kgs)
                            </div>
                            <div className="font-bold mt-6">
                            {item?.measurements?.id == 3 ? 'Net weight of rotis (Kgs)' : 'Net weight of pieces (Kgs)'}
                            </div>
                            <div className="font-bold mt-7">
                            {item?.measurements?.id == 3 ? 'No of rotis(A)' : 'No of pieces(A)'}
                            </div>
                          </div>
                          <div className="border-l-2  border-l-red-500  border-b-2 border-b-red-500 p-[13px]">
                            <div className="font-bold mt-[2px]">
                              No of icebox / bowl
                            </div>
                            <div className="font-bold mt-7">
                            {item?.measurements?.id == 3 ? 'Rotis in 1 icebox (nos)' : 'Pieces in 1 icebox (nos)'}
                            </div>
                            <div className="font-bold mt-7">
                            {item?.measurements?.id == 3 ? 'No. of rotis (B)' : 'No. of pieces (B)'}
                            </div>
                          </div>

                          <div className="border-l-2 border-l-red-500 border-t-red-500 border-b-2 border-b-red-500 p-[13px]">
                            <div className="font-bold mt-[1px]">
                            {item?.measurements?.id == 3 ? 'No. of rotis (C)' : 'No. of pieces (C)'}
                            </div>
                          </div>
                          <div className="border-l-2 border-l-red-500 border-t-red-500 border-b-2 border-b-red-500 p-[13px]">
                            <div className="font-bold ">
                            {item?.measurements?.id == 3 ? 'Total No. Of Rotis' : 'Total No. Of Pieces'}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    {Array.from({ length: batchSize }, (_, index) => (
                      <div
                        key={index}
                        className="  gap-5 mb-4 mt-10 flex-shrink-0 w-40"
                      >
                        <div
                          className={`border border-t-2 ${
                            index === 4 ? "border-r-2 border-r-red-500" : ""
                          }  border-t-red-500 p-2`}
                        >
                          {index + 1}
                        </div>

                        {(item?.measurements?.id == 1 ||
                          item?.measurements?.id == 4) && (
                          <>
                            <div className="">
                              <div
                                className={`border p-2  border-t-2 border-t-red-500 ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <Select
                                  {...menuAboveTable}
                                  classNamePrefix="select"
                                  styles={withMenuOnTop(batchSelectStyles)}
                                  name="trolly_name"
                                  value={formData?.[index].trolly_name}
                                  onChange={(selectedOption, name) => {
                                    handleSelectChange(
                                      index,
                                      selectedOption,
                                      name
                                    );
                                  }}
                                  placeholder="Trolly Name"
                                  options={trollyList.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  filterOption={(option, inputValue) => {
                                    return option.data.label
                                      .toLowerCase()
                                      .includes(inputValue.toLowerCase());
                                  }}
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <Select
                                  {...menuAboveTable}
                                  classNamePrefix="select"
                                  styles={withMenuOnTop(batchSelectStyles)}
                                  name="vessel_name"
                                  value={formData?.[index].vessel_name}
                                  onChange={(selectedOption, name) => {
                                    handleSelectChange(
                                      index,
                                      selectedOption,
                                      name
                                    );
                                  }}
                                  placeholder="Vessel Name"
                                  options={vesselList.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  filterOption={(option, inputValue) => {
                                    return option.data.label
                                      .toLowerCase()
                                      .includes(inputValue.toLowerCase());
                                  }}
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="gross_weight_fg"
                                  name="gross_weight_fg"
                                  placeholder="Gross weight FG(Kgs.)"
                                  value={formData?.[index]?.gross_weight_fg}
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="weight_of_empty_trolly"
                                  name="weight_of_empty_trolly"
                                  placeholder="Weight of Empty trolley"
                                  disabled
                                  value={
                                    formData?.[index]?.weight_of_empty_trolly
                                  }
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1"
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="weight_of_empty_vessel"
                                  name="weight_of_empty_vessel"
                                  placeholder="Weight of Empty vessel"
                                  disabled
                                  value={
                                    formData?.[index]?.weight_of_empty_vessel
                                  }
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1"
                                />
                              </div>
                              <div
                                className={`border p-2 border-b-2 border-b-red-500 ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="net_weight_fg_a"
                                  name="net_weight_fg_a"
                                  placeholder="Net weight - FG -(Kgs.)"
                                  disabled
                                  value={formData?.[index]?.net_weight_fg_a}
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1"
                                />
                              </div>

                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="excess_bowl_nos"
                                  name="excess_bowl_nos"
                                  placeholder="Excess Bowl nos."
                                  value={formData?.[index]?.excess_bowl_nos}
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="weight_of_1_filled_bowl"
                                  name="weight_of_1_filled_bowl"
                                  placeholder="Weight of 1 Filled bowl"
                                  value={
                                    formData?.[index]?.weight_of_1_filled_bowl
                                  }
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                                />
                              </div>
                              <div
                                className={`border p-2 border-b-2 border-b-red-500 ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="bowl_filled_weight_b"
                                  placeholder="Bowl Filled Weight (Kgs.)"
                                  disabled
                                  name="bowl_filled_weight_b"
                                  value={
                                    formData?.[index]?.bowl_filled_weight_b
                                  }
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1"
                                />
                              </div>

                              <div
                                className={`border  p-2 border-b-2  border-b-red-500 ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="total_weight"
                                  name="total_weight"
                                  placeholder="Total Weight (Kgs.)"
                                  disabled
                                  value={excessTotal("total_weight")}
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className={`w-full border rounded-md placeholder:text-sm p-1 bg-lime-300 ${index === 0 ? "" : "invisible"}`}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {(item?.measurements?.id == 2 ||
                          item?.measurements?.id == 5) && (
                          <>
                            <div
                              className={`border p-2 border-t-2 border-t-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <Select
                                {...menuAboveTable}
                                classNamePrefix="select"
                                styles={withMenuOnTop(batchSelectStyles)}
                                name="vessel_name"
                                value={formData?.[index].vessel_name}
                                onChange={(selectedOption, name) => {
                                  handleSelectChange(
                                    index,
                                    selectedOption,
                                    name
                                  );
                                }}
                                placeholder="Vessel Name"
                                options={[
                                  { value: "unknown", label: "Unknown" },
                                  ...vesselList.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))
                                ]}
                                filterOption={(option, inputValue) => {
                                  return option.data.label
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase());
                                }}
                              />
                            </div>
                            <div className="border p-2">
                              <input
                                type="number"
                                step="0.01"
                                id="vessel_diameter"
                                name="vessel_diameter"
                                placeholder="Diameter(cms)"
                                value={formData?.[index]?.vessel_diameter ?? ""}
                                onChange={handleInputChange(index)}
                                onBlur={handleBlur(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                disabled={formData?.[index]?.vessel_name?.value !== "unknown"}
                                className={`w-full border rounded-md placeholder:text-sm p-1 ${formData?.[index]?.vessel_name?.value === "unknown" ? "bg-orange-50" : ""}`}
                              />
                            </div>
                            <div className="border p-2">
                              <Select
                                {...menuAboveTable}
                                classNamePrefix="select"
                                styles={withMenuOnTop(batchSelectStylesNoFill)}
                                name="height_selection"
                                value={formData?.[index].height_selection}
                                onChange={(selectedOption, name) => {
                                  handleSelectChange(
                                    index,
                                    selectedOption,
                                    name
                                  );
                                }}
                                placeholder="Height Selection"
                                options={heightSelectionList.map((item) => ({
                                  value: item.value,
                                  label: item.label,
                                }))}
                                onBlur={handleBlur(index)}
                                filterOption={(option, inputValue) => {
                                  return option.data.label
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase());
                                }}
                              />
                            </div>
                            <div className="border p-2">
                              <input
                                type="number"
                                step="0.01"
                                id="height"
                                name="height"
                                placeholder="Height(cms)"
                                // Controlled, like every other input here. As defaultValue it was
                                // uncontrolled, so switching menu items left the previous item's
                                // height in the box -- the same defect fixed on Finished Goods.
                                value={formData?.[index]?.height ?? ""}
                                onChange={handleInputChange(index)}
                                onBlur={handleBlur(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            {/* <div
                              className={`border p-2  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="empty_height"
                                name="empty_height"
                                placeholder="Empty height (cms)"
                                value={formData?.[index]?.empty_height}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div> */}
                            {/* <div
                              className={`border p-2  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="filled_height"
                                name="filled_height"
                                placeholder="Filled height (Cms.)"
                                value={formData?.[index]?.filled_height}
                                onChange={handleInputChange(index)}
                                onBlur={handleBlur(index)}
                                onWheel={(e) => e.target.blur()}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div> */}
                            <div
                              className={`border p-2 border-b-2 border-b-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="vessel_volume"
                                placeholder="Vessel Volume (Ltrs) - A"
                                disabled
                                name="vessel_volume"
                                value={formData?.[index]?.vessel_volume}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>

                            <div
                              className={`border p-2  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="excess_bowl_nos"
                                name="excess_bowl_nos"
                                placeholder="Excess Bowl nos."
                                value={formData?.[index]?.excess_bowl_nos}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="volume_of_1_filled_bowl"
                                name="volume_of_1_filled_bowl"
                                placeholder="Volume of 1 Filled bowl (ltrs.)"
                                value={
                                  formData?.[index]?.volume_of_1_filled_bowl
                                }
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2 border-b-2 border-b-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="bowl_filled_volume"
                                disabled
                                name="bowl_filled_volume"
                                placeholder="Bowl. Filled Volume (ltrs.) - B"
                                value={formData?.[index]?.bowl_filled_volume}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>

                            <div
                              className={`border p-2 border-b-2 border-b-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="total_volume"
                                placeholder="Total Volume (ltrs.)"
                                disabled
                                name="total_volume"
                                value={excessTotal("total_volume")}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className={`w-full border rounded-md placeholder:text-sm p-1 bg-lime-300 ${index === 0 ? "" : "invisible"}`}
                              />
                            </div>
                          </>
                        )}
                        {(item?.measurements?.id == 3 ||
                          item?.measurements?.id == 6) && (
                          <>
                          <div  className={`border p-2 border-t-2 border-t-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}>
                              <Select
                                {...menuAboveTable}
                                classNamePrefix="select"
                                styles={withMenuOnTop(batchSelectStyles)}
                                name="trolly_name"
                                value={formData?.[index].trolly_name}
                                onChange={(selectedOption, name) => {
                                  handleSelectChange(
                                    index,
                                    selectedOption,
                                    name
                                  );
                                }}
                                placeholder="Trolly Name"
                                options={trollyList.map((item) => ({
                                  value: item.id,
                                  label: item.name,
                                }))}
                                filterOption={(option, inputValue) => {
                                  return option.data.label
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase());
                                }}
                              />
                            </div>
                            <div
                              className={`border p-2  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="gross_weight"
                                name="gross_weight"
                                placeholder="Gross weight (Ice box+Rotli)"
                                value={formData?.[index]?.gross_weight}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="no_of_bowl_icebox"
                                name="no_of_bowl_icebox"
                                placeholder="Total IceBox (nos)"
                                value={formData?.[index]?.no_of_bowl_icebox}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="weight_of_1_roti"
                                placeholder={item?.measurements?.id == 3 ? "Weight of 1 roti" : "Weight of 1 piece"}
                                name="weight_of_1_roti"
                                value={formData?.[index]?.weight_of_1_roti}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                                <input
                                  type="number"
                                  step="0.01"
                                  id="weight_of_empty_trolly"
                                  name="weight_of_empty_trolly"
                                  placeholder="Weight of Empty trolley"
                                  disabled
                                  value={
                                    formData?.[index]?.weight_of_empty_trolly
                                  }
                                  onChange={handleInputChange(index)}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                  className="w-full border rounded-md placeholder:text-sm p-1"
                                />
                              </div>
                              <div
                                className={`border p-2  ${
                                  index === 4
                                    ? "border-r-2 border-r-red-500"
                                    : ""
                                }`}
                              >
                              <Select
                                {...menuAboveTable}
                                classNamePrefix="select"
                                styles={withMenuOnTop(batchSelectStyles)}
                                name="bowl_type"
                                value={formData?.[index].bowl_type}
                                onChange={(selectedOption, name) => {
                                  handleSelectChange(
                                    index,
                                    selectedOption,
                                    name
                                  );
                                }}
                                placeholder="Bowl Type"
                                options={bowlList.map((item) => ({
                                  value: item.id,
                                  label: item.name,
                                }))}
                                filterOption={(option, inputValue) => {
                                  return option.data.label
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase());
                                }}
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="weight_of_1_empty_bowl_icebox"
                                name="weight_of_1_empty_bowl_icebox"
                                placeholder="Weight of 1 empty Icebox / bowl"
                                // disabled
                                value={
                                  formData?.[index]
                                    ?.weight_of_1_empty_bowl_icebox
                                }
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="total_weight_of_empty_bowl_icebox"
                                placeholder="Total Weight of empty Icebox / bowl"
                                disabled
                                name="total_weight_of_empty_bowl_icebox"
                                value={
                                  formData?.[index]
                                    ?.total_weight_of_empty_bowl_icebox
                                }
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>
                            
                            
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="net_weight_of_rotis"
                                placeholder={item?.measurements?.id == 3 ? "Net weight of rotis" : "Net weight of pieces"}
                                disabled
                                name="net_weight_of_rotis"
                                value={formData?.[index]?.net_weight_of_rotis}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>
                            
                            <div
                              className={`border p-2 border-b-2 border-b-red-500  ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="no_of_rotis_a"
                                placeholder={item?.measurements?.id == 3 ? "No of rotis(A)" : "No of pieces(A)"}
                                disabled
                                name="no_of_rotis_a"
                                value={formData?.[index]?.no_of_rotis_a}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>

                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="no_of_bowl_icebox_b"
                                placeholder="No of icebox / bowl"
                                name="no_of_bowl_icebox_b"
                                value={formData?.[index]?.no_of_bowl_icebox_b}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="nos_in_1_bowl_icebox"
                                name="nos_in_1_bowl_icebox"
                                placeholder={item?.measurements?.id == 3 ? "Rotis in 1 icebox (nos)" : "Pieces in 1 icebox (nos)"}
                                disabled
                                value={formData?.[index]?.nos_in_1_bowl_icebox}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 "
                              />
                            </div>
                            <div
                              className={`border p-2 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="no_of_rotis_b"
                                placeholder={item?.measurements?.id == 3 ? "No.of rotis (B)" : "No.of pieces (B)"}
                                disabled
                                name="no_of_rotis_b"
                                value={formData?.[index]?.no_of_rotis_b}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1"
                              />
                            </div>

                            <div
                              className={`border p-2 border-t-2  border-t-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="no_of_rotis_c"
                                placeholder={item?.measurements?.id == 3 ? "No.of rotis (C)" : "No.of pieces (C)"}
                                name="no_of_rotis_c"
                                value={formData?.[index]?.no_of_rotis_c}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className="w-full border rounded-md placeholder:text-sm p-1 bg-orange-50"
                              />
                            </div>

                            <div
                              className={`border p-2 border-t-2 border-t-red-500 border-b-2 border-b-red-500 ${
                                index === 4 ? "border-r-2 border-r-red-500" : ""
                              }`}
                            >
                              <input
                                type="number"
                                step="0.01"
                                id="total_no_of_roti"
                                placeholder={item?.measurements?.id == 3 ? "Total No. Of Rotis" : "Total No. Of Pieces"}
                                disabled
                                name="total_no_of_roti"
                                value={excessTotal("total_no_of_roti")}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                className={`w-full border rounded-md placeholder:text-sm p-1 bg-lime-300 ${index === 0 ? "" : "invisible"}`}
                              />
                            </div>
                          </>
                        )}

                        {/* <div className="border p-2">
                                            <Select
                                                {...menuAboveTable}
                                                classNamePrefix="select"
                                                name="timeslot"  
                                                value={formData?.[index].timeslot} 
                                                onChange={(selectedOption, name) => {
                                                    handleSelectChange(index,selectedOption, name);
                                                }}                                     
                                                options={timeSlotList.map(item => ({
                                                    value: item.value,
                                                    label: item.label
                                                }))}
                                                filterOption={(option, inputValue) => {
                                                    return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                                }}
                                            />
                                        </div>
                                        <div className="border p-2"><input type="text" id="requisition_no" name="requisition_no" value={formData?.[index]?.requisition_no} onChange={handleInputChange(index)} className="w-full border rounded-md placeholder:text-sm p-1" />	</div> */}

                        <div className="border p-2">
                          <button
                            onClick={(e) => {
                              handleSave(e, index);
                            }}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm p-1 mr-2"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExcessScreen;
